/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UnlinkRfidTagsRequest
 */
export interface UnlinkRfidTagsRequest {
    /**
     *
     * @type {Array<number>}
     * @memberof UnlinkRfidTagsRequest
     */
    rfidTagIds?: Array<number>;
}

/**
 * Check if a given object implements the UnlinkRfidTagsRequest interface.
 */
export function instanceOfUnlinkRfidTagsRequest(
    value: object,
): value is UnlinkRfidTagsRequest {
    return true;
}

export function UnlinkRfidTagsRequestFromJSON(
    json: any,
): UnlinkRfidTagsRequest {
    return UnlinkRfidTagsRequestFromJSONTyped(json, false);
}

export function UnlinkRfidTagsRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UnlinkRfidTagsRequest {
    if (json == null) {
        return json;
    }
    return {
        rfidTagIds: json["rfidTagIds"] == null ? undefined : json["rfidTagIds"],
    };
}

export function UnlinkRfidTagsRequestToJSON(
    value?: UnlinkRfidTagsRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        rfidTagIds: value["rfidTagIds"],
    };
}
